import { SagaReturnType, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  doSucceededGetQuoteList,
  doSucceededGetQuote,
  doSucceededGetQuoteChart,
  doFailedGetQuoteList,
  doFailedGetQuote,
  doFailedGetQuoteChart,
} from 'src/actions';
import { getClientApi, QuoteApi } from 'src/data-communication';
import { GetQuoteChartDto, GetQuoteDto, GetQuoteListDto } from 'src/dtos';
import { getPayloadFromErrorResponse } from 'src/utils';

import { State, Type } from '../actions/utils';
import { TReduxAction } from '../typings/commonTypes';

export function* list(action: TReduxAction) {
  try {
    const dto: GetQuoteListDto = action.payload;
    const { authToken } = yield select(state => state.auth.data);
    const response: SagaReturnType<QuoteApi['list']> = yield call(getClientApi().quote.list, {
      ...dto,
      authToken,
    });
    yield put(doSucceededGetQuoteList(response));
  } catch (error) {
    const payload = getPayloadFromErrorResponse(error);
    yield put(doFailedGetQuoteList(payload));
  }
}

export function* retrieve(action: TReduxAction) {
  try {
    const dto: GetQuoteDto = action.payload;
    const { authToken } = yield select(state => state.auth.data);
    const response: SagaReturnType<QuoteApi['retrieve']> = yield call(getClientApi().quote.retrieve, {
      ...dto,
      authToken,
    });
    yield put(doSucceededGetQuote(response));
  } catch (error) {
    const payload = getPayloadFromErrorResponse(error);
    yield put(doFailedGetQuote(payload));
  }
}

export function* retrieveChart(action: TReduxAction) {
  try {
    const dto: GetQuoteChartDto = action.payload;
    const { authToken } = yield select(state => state.auth.data);
    const response: SagaReturnType<QuoteApi['retrieveChart']> = yield call(getClientApi().quote.retrieveChart, {
      ...dto,
      authToken,
    });
    yield put(doSucceededGetQuoteChart({ ...response, symbol: dto.params.symbol }));
  } catch (error) {
    const payload = getPayloadFromErrorResponse(error);
    yield put(doFailedGetQuoteChart(payload));
  }
}

/**
 * Quote Media
 */
export function* registerQuoteSagas() {
  yield takeEvery(State.actionRequested(Type.GET_QUOTE_LIST), list);
  yield takeEvery(State.actionRequested(Type.GET_QUOTE), retrieve);
  yield takeEvery(State.actionRequested(Type.GET_QUOTE_CHART), retrieveChart);
}
